/**
 * Tailwind class strings for the Pagination component.
 * Mobile-first; the min-[651px] variant is the desktop breakpoint, matching the legacy m-notMobile boundary.
 */

// Row wrapper (PLP search footer): centered on mobile, right-aligned with top spacing on desktop.
export const paginationClasses = 'flex items-center gap-2 justify-center min-[651px]:pt-8 min-[651px]:justify-end';

// Row wrapper (grouped control, e.g. account): the caret + cell row, no page-level spacing/alignment
// (the consumer's own wrapper handles layout, e.g. the group wrapper's justify-between selector row).
export const paginationGroupClasses = 'flex items-center gap-2';

// Outer wrapper for the grouped control: "items per page" selector on the left, control on the right.
export const paginationGroupWrapperClasses = 'flex items-center justify-between max-[650px]:px-3';

// "Items per page" label + select cluster.
export const pageSizeClasses = 'flex items-center gap-2';

// The <select> itself (mirrors the SortSelect Tailwind treatment); pair with an overlaid chevron.
export const pageSizeSelectClasses = 'body-s h-10 appearance-none rounded-sm border border-subtle bg-gray-0 py-2 pl-3 pr-9 text-gray-900';

// Chevron overlaid on the select (absolutely positioned; non-interactive).
export const pageSizeChevronClasses = 'pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-700';

// Numbered-cell group between the carets; wider gap on mobile.
export const cellsClasses = 'flex items-center gap-1 min-[651px]:gap-0.5';

// Shared 32x32 geometry for every page cell.
const cellBaseClasses = 'flex h-8 w-8 items-center justify-center';

// Inactive page number link.
export const cellClasses = `${cellBaseClasses} body-s text-gray-900 no-underline`;

// Active page number: highlighted pill with an underlined digit.
export const cellActiveClasses = `${cellBaseClasses} p-1 body-s-medium rounded-sm bg-gray-50 text-gray-900 underline decoration-1 underline-offset-4`;

// Truncation ellipsis cell.
export const ellipsisClasses = 'flex w-4 items-center justify-center body-s text-gray-900';

// Prev/next caret states; stroke follows currentColor.
export const caretEnabledClasses = 'text-gray-900';
export const caretDisabledClasses = 'text-gray-400 pointer-events-none';
